import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React, { useState, lazy, Suspense, useEffect } from "react";
// import Home from './components/HomePage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { ThemeContext } from './contexts/theme-context';
import { WalletContext } from './contexts/Wallet-context';
import { getDefaultTheme } from './Utils/utils';
import { isTelegramWebApp } from './Utils/utils';
import TokenDetails from './components/TokenDetailsPage';
import CallersList from './components/CallersListPage';
import MarqueeComponent from './components/UI/MarqueeComponent';
import AdSlider from './components/UI/AdSlider';
import Banner from './components/UI/AdBanner';
import ReactGA from "react-ga4";
import BannerRotator from './components/UI/BannerRotator';
import LeftSideDesktopNav from './components/LeftSideDesktopNav';
import * as httpService from './services/HTTPService';
import TelegramFooter from './components/TelegramApp/TelegramFooter';
import WalletPage from './components/WalletPage';
import { StrictMode } from "react";


const TRACKING_ID = "G-FZSWG6ZVH9"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
// import SocialLinks from './components/SocialLinks';

//import NotFound from './components/NotFound';
// import TokenDetails from './components/TokenDetails';
//const TokenDetails = lazy(() => import('./components/TokenDetailsPage'));
const NotFound = lazy(() => import('./components/NotFoundPage'));
const About = lazy(() => import('./components/AboutPage'));
const News = lazy(() => import('./components/NewsPage'));
const OurVision = lazy(() => import('./components/OurVisionPage'));
const OurVisionTwo = lazy(() => import('./components/OurVisionPage2'));
const Partners = lazy(() => import('./components/PartnersPage'));
const Calls = lazy(() => import('./components/CallsPage'));
const Signals = lazy(() => import('./components/SignalsPage'));
const WhyShillguard = lazy(() => import('./components/WhyShillguard'));
const OurToken = lazy(() => import('./components/OurToken'));
const WhatsNext = lazy(() => import('./components/WhatsNext'));
const TermsOfUse = lazy(() => import('./components/TermsOfUsePage'));
const LegalAdvice = lazy(() => import('./components/LegalAdvicePage'));
const TeamPage = lazy(() => import('./components/TeamPage'));
const RoadMap = lazy(() => import('./components/RoadMapPage'));
const StakingPage = lazy(() => import('./components/StakingPage'));
const TelegramBots = lazy(() => import('./components/TelegramBots'));
const APIDashboard = lazy(() => import('./components/APIDashboard'));
const NetworkScans = lazy(() => import('./components/NetworkScans'));
const ShillDetectBot = lazy(() => import('./components/ShillDetectBot'));
const ShillNewsBot = lazy(() => import('./components/ShillNewsBot'));
const TelegramApp = lazy(() => import('./components/TelegramApp'));
const PremiumPlans = lazy(() => import('./components/PremiumPlans'));
const TeamsPageV2 = lazy(() => import('./components/TeamPageNew/TeamsPage-v2'));
const StatsPage = lazy(() => import('./components/StatsPage'));
const TasksPage = lazy(() => import('./components/TasksPage'));


const App = () => {

  const [theme, setTheme] = useState(getDefaultTheme());
  const [wallet, setWallet] = useState(localStorage.getItem('userWallet') || null);
  let [tokens, setTokens] = useState([]);
  let [requested, setRequested] = useState(false);
  const velocity = window.innerWidth / 40;
  const isCallsPage = (window.location.href.indexOf('/calls') !== -1 && window.location.href.indexOf('/tokens') === -1) || window.location.pathname === '/';
  const isNoBackgroundPage = window.location.href.indexOf('/calls') !== -1 || window.location.href.indexOf('/tokens') !== -1 || window.location.href.indexOf('/callers/') !== -1;
  const callPageClass = isCallsPage ? 'calls-page' : '';
  const nobgPageClass = isNoBackgroundPage ? 'no-background' : '';
  const isWebHomePage = ((window.location.href.indexOf('/signals') !== -1  || window.location.pathname === "/") && !isTelegramWebApp());
  const isMarqueeVisible = (isWebHomePage || window.location.href.indexOf('/stats') !== -1);
  const visiblePopupPages = window.location.href.indexOf('/callers/') !== -1 || window.location.href.indexOf('/tokens/') !== -1;
  const userWallet = localStorage.getItem('userWallet');
  let userSgtBalance = null;  
  const [isTelegramApp, setIsTelegramApp] = useState(false);
  if(userWallet) {
    userSgtBalance = JSON.parse(userWallet).amount;
  }
  const visiblePopup = visiblePopupPages && (userSgtBalance === null || parseFloat(userSgtBalance) < 1);

  //const [hiddenTopAd, setHiddenTopAd] = useState('');
  //const callPageClass = '';

  useEffect(() => {
    const pathName = window.location.pathname.split('/')[1];
    const title = pathName ? pathName + ' - Shillguard' : 'Shillguard';
    document.title = title;
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    const rootElement = document.getElementById('root');
    if(window.innerWidth < 901) {
      document.getElementById('root').classList.add('mobile-app');
      document.getElementById('root').classList.remove('desktop-app');
    }
    else {
      document.getElementById('root').classList.add('desktop-app');
      document.getElementById('root').classList.remove('mobile-app');
      if(rootElement && localStorage.getItem('navClass')) {
        rootElement.classList.add('sgt-menu-open');
      }
    }
    
    if(rootElement) {
      if (isTelegramWebApp()) {
        rootElement.classList.add('telegram-app');
        document.querySelector('body').classList.add('telegram-app-body');
      }
      else {
        rootElement.classList.add('browser-app');
      }
    }
    
  }, []);

  const toggleActiveTelegramMenuBtn = () => {
    const isTelegramApp = isTelegramWebApp();
    if(isTelegramApp) {
      //tgr-footer-menu-button
      const locationPath = window.location.pathname;
      const buttons = document.querySelectorAll('.tgr-footer-menu-button');
      buttons.forEach((btn) => {
        const buttonName = btn.querySelector('a').getAttribute('href').replace('/', '');
        if(locationPath.indexOf(buttonName.toLowerCase()) !== -1) {
          document.querySelector('.tgr-footer-menu-button.active').classList.remove('active');
          btn.classList.add('active');
        }
      })
    }
  }

  const closeMainMenu = (e) => {
    const expandMenu = document.querySelector('.expand-left-nav');
    const root = document.querySelector('.sgt-menu-open');
    if(expandMenu) {
      // check for closest element
      if(!e.target.closest('left-side-nav') && 
      e.target.className !== "open-mob-menu" && 
      e.target.className !== "toggle-m-btn" &&
      e.target.className.indexOf("menu-icon") === -1 ) {
        // expandMenu.classList.remove('expand-left-nav');
        // if(root) {
        //   root.classList.remove('sgt-menu-open');
        // }
      }
    }
  }

  useEffect(() => {
    toggleActiveTelegramMenuBtn();
    document.addEventListener('click', closeMainMenu);
    if(isCallsPage) {
      // setTimeout(() => {
      //   localStorage.removeItem('top5Tokens');
      //   localStorage.removeItem('top5Callers');
      // }, 1000);
      const el = document.querySelector('.app-header');
      const marqueeSlider = document.querySelector('.marq-slider');
      const onScroll = () => {
        const topGrids = document.querySelector('.top-grids');
        if (window.scrollY === 0) {
          //setHiddenTopAd('');
          if(el) {
            el.classList.remove('hidden-top-ads');
          }
          if(marqueeSlider) {
            marqueeSlider.classList.remove('marq-hidden-top-ads');
          }
          if(topGrids) {
            topGrids.classList.remove('topGrids-hidden-top-ads');
          }
        }
        else {
          if(el) {
            el.classList.add('hidden-top-ads');
          }
          if(marqueeSlider) {
            marqueeSlider.classList.add('marq-hidden-top-ads');
          }
          if(topGrids) {
            topGrids.classList.add('topGrids-hidden-top-ads');
          }
          //setHiddenTopAd('hidden-top-ads');
        }
        
      }
      document.addEventListener('scroll', onScroll);
      document.addEventListener('click', closeMainMenu);
      return () => {
        document.removeEventListener('scroll', onScroll);
        document.removeEventListener('click', closeMainMenu);
      }
    }
    return () => {
        document.removeEventListener('click', closeMainMenu);
      }
  }, []);

  useEffect(()=> {

    if(isMarqueeVisible) {
      if(!requested) {
        requested = true;
        setRequested(true);
        httpService.getTopTrendingTokens().then((res) => {
          setTokens(res);
        })
      }
    }
  }, [])

  return (
    <StrictMode>
<WalletContext.Provider value={{ wallet, setWallet }}>
      <ThemeContext.Provider value={{ theme, setTheme }}>
        <LeftSideDesktopNav />
        <div className='top-ads'>
          {/* {isCallsPage ? <Banner /> : null} */}
          {isCallsPage ? (
            <div>
              {/* <a href="https://coinsult.net/" target='_blank'>
                <img alt="top_banner" src="/img/Banner_Coinsult.png" loading="lazy" />
              </a> */}
              {/* <BannerRotator 
                  rotatorInterval={10000} 
                  //imgArray={[{src: "/img/Banner_Coinsult.png", href: "https://coinsult.net/", alt: "coinsult banner" }, {src: "/img/Banner_Pulse_AI.png", href: "https://pulseai.info", alt: "pulseai banner" }]}
                  imgArray={[{src: "/img/three.JPG", href: "http://threeprotocol.ai/", alt: "top banner" }]} 
              /> */}
            </div>
          ) : null}
        </div>
        <div className={`theme-container theme-${theme} ${callPageClass} ${nobgPageClass} ${isTelegramApp ? 'telegram-app' : ''} `}>
          <Header />
          {isMarqueeVisible ? (
            <div className="marq-slider tr-tokens flex-box">
                <div className='marq-bg'>
                  <div className='marq-inner'>
                    <h3>Trending <span>tokens</span></h3>
                    <MarqueeComponent source={tokens} velocity={velocity} minScale={0.7} resetAfterTries={200}> </MarqueeComponent>
                  </div>
                </div>
            </div>
          ) : null}
          
          {/* {isCallsPage ? (
            <div className='adslider-outer'>
              <AdSlider />
            </div>
          ) : null} */}
          <div className='main-out'>
            <div className='main-l'>
              <div className='main-l-t'>
                {/* <img alt="Left_top_bg" src="/img/Left_top_960x1700.png" loading="lazy" /> */}
              </div>
              <div className='main-l-m'>
                {/* <img alt="Left_top_bg" src="/img/Left_mid_960x1500.png" loading="lazy" /> */}
              </div>
            </div>
            <div className='main-content'>
              <Suspense fallback={<div className="container">Loading...</div>}>
                <Router>
                  <Routes>
                    {/* routes go here, as children */}
                    <Route path="/" element={<Signals />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/roadmap" element={<RoadMap />} />
                    <Route path="/staking" element={<StakingPage />} />
                    <Route path="/team" element={<TeamsPageV2 />} />
                    <Route path="/WhyShillguard" element={<WhyShillguard />} />
                    <Route path="/ourtoken" element={<OurToken />} />
                    <Route path="/whatsnext" element={<WhatsNext />} />
                    <Route path="/vision" element={<OurVision />} />
                    <Route path="/vision2" element={<OurVisionTwo />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/calls" element={<Calls />} />
                    <Route path="/signals" element={<Signals />} />
                    <Route path="/terms" element={<TermsOfUse />} />
                    <Route path="/legal-advice" element={<LegalAdvice />} />
                    <Route path="/tokens/:tokenName" element={<TokenDetails />} />
                    <Route path="/callers/:tokenName" element={<CallersList />} />
                    <Route path="/TelegramBots" element={<TelegramBots />} />
                    <Route path="/APIDashboard" element={<APIDashboard />} />
                    <Route path="/NetworkScans" element={<NetworkScans />} />
                    <Route path="/ShillDetectBot" element={<ShillDetectBot />} />
                    <Route path="/ShillNewsBot" element={<ShillNewsBot />} />
                    <Route path="/TelegramApp" element={<TelegramApp />} />
                    <Route path="/premiumplans" element={<PremiumPlans />} />
                    <Route path="/wallet" element={<WalletPage />} />
                    <Route path="/tasks" element={<TasksPage />} />
                    <Route path="/stats" element={<StatsPage />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Router>
              </Suspense>
            </div>
            <div className='main-r'>
              <div className='main-r-t'>
                {/* <img alt="Right_top_bg" src="/img/Right_top_960x1700.png" loading="lazy" /> */}
              </div>
              <div className='main-r-m'>
                {/* <img alt="Right_top_bg" src="/img/Right_mid_960x1500.png" loading="lazy" /> */}
              </div>
            </div>
          </div>
          {/* Когато юзъра не е вързал уолет, или и да е, но няма SGT в него. Поп-ъпа излиза в тези случаи в страниците на Груп профил и Токен профил. */}
            
            {isTelegramWebApp() ? (
                <TelegramFooter />
            ) : (
                <Footer />  
            )}
          
        </div>
      </ThemeContext.Provider>
    </WalletContext.Provider>
    </StrictMode>
    
  );
};

export default App;